import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const markNotificationsAsRead = () => {
  return restApiClient
    .url(constructApiUrl(API.notifications.markNotificationsAsRead.url, null))
    .post()
}
